import { Injectable } from '@angular/core';
import { take, tap } from 'rxjs/operators';
import { VersionControlRequest } from '../SicorService/RequestObject/VersionControlRequest';
import { SicorApiService } from '../SicorService/sicor-api.service';
import { VersionControlResponse } from '../SicorService/ResponseObject/VersionControlResponse';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VersionControlService {
  constructor(private sicorAPI: SicorApiService) { }


  public async checkVersionApp(requestParams: VersionControlRequest, token: string): Promise<VersionControlResponse> {
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.checkVersion(requestParams, token)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet[0] != null) {
              const versionControlResponse: VersionControlResponse = new VersionControlResponse(res.resultSet[0].lockapp === 0 ? false : true, res.resultSet[0].message, res.resultSet[0].urlstore,
                res.resultSet[0].error, res.resultSet[0].videoLiveTime != null ? res.resultSet[0].videoLiveTime : 0);
              resolve(versionControlResponse);
            } else {
              const versionControlResponse: VersionControlResponse = new VersionControlResponse(false, '', '', 500, 0);
              resolve(versionControlResponse);
            }
          }, error: e => {
            const versionControlResponse: VersionControlResponse = new VersionControlResponse(false, '', '', 500, 0);
            resolve(versionControlResponse);
          }
        })
      ));
    });
  }
}